import React from 'react';
import {Steps} from './app-screen';
import SpaceLike from '../components/Space';
import styled from 'styled-components';
import {
  TextAlignment,
  TokenTextAppearance,
  Text,
  CTA,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import {ContinueButton} from './common-components';
import {useHistory} from 'react-router-dom';
import ArIcon from './ar-icon';
import {useSendAmpChargeAnalytic} from '../hooks/useSendAmpChargeAnalytic';

const StyledText = styled(Text)`
  color: white;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 69px;
  color: #fff;

  & > div {
    font-size: 32px;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 54px;
  padding-bottom: 40px;
`;

// border-bottom: 1px solid rgba(255, 255, 255, 0.5);

// const DisclaimerContainer = styled.div`
//   opacity: 0.5;
// `;

const ExploreButton = styled(ContinueButton)`
  height: 56px;
`;

const SecondaryButton = styled(CTA)`
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
  width: 100%;
  height: 56px;
  margin-top: 16px;

  &:hover {
    background: transparent;
    border: 1px solid #fff;
  }
`;

const CustomersArButton = styled(ContinueButton)`
  height: 56px;

  &:hover {
    * > path {
      transition: fill 0.2s;
      fill: #fff;
    }
  }
  }
`;

type Props = {
  setStep: (step: Steps) => void;
  isCustomers?: boolean;
};

const FinalStep: React.FC<Props> = ({setStep, isCustomers}) => {
  const history = useHistory();
  const {handleFinalStepCTAClick} = useSendAmpChargeAnalytic();

  return (
    <SpaceLike
      direction="vertical"
      customStyles={{
        textAlign: 'center',
        justifyContent: 'center',
        paddingBottom: 'calc(50px + env(safe-area-inset-bottom))',
        paddingTop: 'calc(50px + env(safe-area-inset-top))',
      }}
    >
      <StyledText
        appearance={TokenTextAppearance.label200}
        textAlign={TextAlignment.center}
        bold
      >
        What&apos;s next?
      </StyledText>
      <TextContainer>
        <Text
          appearance={TokenTextAppearance.headline300}
          textAlign={TextAlignment.center}
          color={TokenTextColor.inherit}
        >
          {isCustomers ? 'Time to use' : 'Take charge'}
        </Text>
        <Text
          appearance={TokenTextAppearance.headline300}
          textAlign={TextAlignment.center}
          color={TokenTextColor.inherit}
          bold
        >
          {isCustomers ? 'your photos' : 'in an eVW'}
        </Text>
      </TextContainer>
      <StyledText
        appearance={TokenTextAppearance.copy200}
        textAlign={TextAlignment.center}
      >
        {isCustomers ? (
          <>
            <div>
              Now that you’ve captured your AmpCharge EV charger in its
              preferred location, simply exit the AR experience to continue your
              application.
            </div>
            <div style={{marginTop: 24}}>
              Please note: you will also need to provide other photos that are
              outlined in the application.
            </div>
          </>
        ) : (
          <span>
            Now that you’ve seen what our AmpCharge EV charger could look like
            at your home, all you need is an eVW to plug it into. Explore our
            range today and find your ideal&nbsp;match.
          </span>
        )}
      </StyledText>
      <ButtonContainer>
        {isCustomers ? (
          <CustomersArButton
            onClick={() => {
              handleFinalStepCTAClick('Back to AR');
              setStep(Steps.CHOOSE);
            }}
            icon={<ArIcon style={{marginRight: '2px'}} color="#001E50" />}
            emphasis="secondary"
            tag="button"
          >
            Back to AR
          </CustomersArButton>
        ) : (
          <>
            <ExploreButton
              onClick={() => {
                history.push(
                  'https://www.volkswagen.com.au/en/hybrid-and-electric.html',
                );
                handleFinalStepCTAClick('Explore our EV Range');
              }}
              emphasis="secondary"
              tag="button"
            >
              Explore our EV Range
            </ExploreButton>
            <SecondaryButton
              onClick={() => {
                handleFinalStepCTAClick('Back to AR');
                setStep(Steps.CHOOSE);
              }}
              icon={<ArIcon style={{marginRight: '2px'}} />}
              emphasis="secondary"
              tag="button"
            >
              Back to AR
            </SecondaryButton>
          </>
        )}
      </ButtonContainer>
      {/* Disclaimer to be added when confirmed */}
      {/* <DisclaimerContainer>
        <StyledText
          appearance={TokenTextAppearance.copy100}
          textAlign={TextAlignment.left}
          bold
        >
          Disclaimer
        </StyledText>
        <StyledText
          appearance={TokenTextAppearance.copy100}
          textAlign={TextAlignment.left}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras a mauris
          dapibus, bibendum metus eu, ultricies neque. Etiam accumsan ligula
          sem, in varius eros pretium sit amet. Aenean tincidunt nunc vitae
          ultricies faucibus. Pellentesque sed leo iaculis, pharetra tellus
          quis, volutpat lorem. Pellentesque sit amet dolor id tortor vestib{' '}
        </StyledText>
      </DisclaimerContainer> */}
    </SpaceLike>
  );
};

export default FinalStep;
